/**
 * QualityCheckBadges — small red pills surfacing post-call quality checks
 * that fired on a run. Hover a badge for the signals payload.
 *
 * Source: ModelOutput.qualityChecks, persisted by
 * `runAnalysisStep` → `evaluateQualityChecks` (see
 * Backend/functions/src/analysis/qualityChecks.ts).
 */
import type { ModelOutput } from '../../../types';

interface Props {
    qualityChecks?: ModelOutput['qualityChecks'];
}

export function QualityCheckBadges({ qualityChecks }: Props) {
    const fired = (qualityChecks || []).filter(c => c.fired);
    if (fired.length === 0) return null;
    return (
        <div className="parsed-feedback-quality-badges">
            {fired.map((c, i) => (
                <span
                    key={i}
                    className="parsed-feedback-quality-badge"
                    title={c.signals ? JSON.stringify(c.signals, null, 2) : undefined}
                >
                    ⚠ {c.name}
                </span>
            ))}
        </div>
    );
}
